import React from 'react';

import cn from 'utils/classNames';

export const NavbarBox = ({ className, children }) => {
  return <div className={cn(className)}>{children}</div>;
};
